import React from "react";
import { Row, Col, Dropdown, OverlayTrigger, Tooltip } from "react-bootstrap";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip as RechartsTooltip, Legend, ResponsiveContainer } from "recharts";
import OrganizationStatsChart from "../../../Components/common/OrganizationStatsChart";
import RegisterChart from "../../../Components/common/RegisterChart";
import ActivityChart from "../../../Components/common/ActivityChart";
import CustomCarousel from "../../../Components/common/CustomCarousel";
import { FilterIcon, NoDataMessage, LoadingMessage } from "../DashboardMessages";
import { FaArrowUp, FaArrowDown, FaSort } from "react-icons/fa";

export const StaffView = (props) => {
  const {
    isLoading, showOrganisationDashboardError, staffStatsData,
    organisationDashboardSharedVideoPerSchoolStatus,
    organisationDashboardSharedVideoPerSchool, fallbackThumb,
    organisationDashboardCategoryPerSchool, usageHoursData, hasUsageHoursData,
    activityData, hasActivityData, registerData, userData, categoryData,
    trendingTags, setSortTags, sortTags, videoData, sortBy, setSortBy,
    recentClasses, totalClassesCount, setSortClasses, sortClasses, sortClassOptions,
    sortOrder, setSortOrder, recentCollections, totalCollectionsCount, sortCollectionOptions,
    setSortCollections, sortCollections, recentStaff, totalStaffCount,
    organisationDashboardRecentClassesStatus, organisationDashboardRecentCollectionsStatus,
    organisationDashboardRecentActiveStaffStatus, organisationDashboardStaffSharedVideosStatus,
    organisationDashboardStaffSharedVideos,
    activeRole, isDateFilter, formatLastActive, navigate, Encryptedid, groupData
  } = props;

  return (
          <>

            <Row className="mb-3">
              <Col xxl={7} lg={12} xl={7} className="mt-4">
                <div className="shadow-sm d-flex flex-column" style={{ height: "650px", background: "#ffffff66", borderRadius: "20px", border: "1px solid #F4F7FE", padding: "15px 20px" }}>
                  <div className="recently-active-chart d-flex flex-column h-100">
                    <div className="recently-main-sec d-flex flex-wrap justify-content-between align-items-center gap-2 mb-4">
                      <div className="recently-head">
                        <h2 className="f-24 m-0" style={{ color: "#2B3674", fontSize: "22px", fontWeight: "700" }}>Recently Active Classes</h2>
                        {isDateFilter ? (
                          recentClasses.length > 0 && (
                            <div className="total-class-head mt-1">
                              <p className="m-0" style={{ color: "#A3AED0", fontSize: "14px" }}>
                                {recentClasses.length} active classes during this period
                              </p>
                            </div>
                          )
                        ) : (
                          recentClasses.length > 0 && (
                            <div className="total-class-head mt-1">
                              <p className="m-0" style={{ color: "#A3AED0", fontSize: "14px" }}>
                                {recentClasses.length} classes total
                              </p>
                            </div>
                          )
                        )}
                      </div>

                      <div className="dash-drop-ad d-flex align-items-center gap-3">
                        <Dropdown onSelect={setSortClasses}>
                          <Dropdown.Toggle
                            variant="success"
                            id="dropdown-classes-sort"
                            className="d-flex align-items-center gap-2"
                            style={{ background: "#F4F7FE", border: "none", color: "#2B3674", borderRadius: "12px", padding: "8px 16px", fontSize: "14px", fontWeight: "600" }}
                          >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                              <path d="M3 6h18M6 12h12m-9 6h6" />
                            </svg>
                            {sortClassOptions[sortClasses] || "Recently updated"}
                          </Dropdown.Toggle>
                          <Dropdown.Menu style={{ borderRadius: "12px", border: "none", boxShadow: "0 10px 25px rgba(0,0,0,0.1)" }}>
                            <Dropdown.Item eventKey="updatedAt">Recently updated</Dropdown.Item>
                            <Dropdown.Item eventKey="createdAt">Recently created</Dropdown.Item>
                            <Dropdown.Item eventKey="withMostCollections">Most shared</Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </div>
                    <div className="recently-card scrollable-card-list flex-grow-1" style={{ overflowY: "auto", overflowX: "hidden", paddingRight: "5px", minHeight: 0 }}>
                      <Row className="mx-0">
                        <Col lg={12}>
                          <Row>
                            {isLoading || organisationDashboardRecentClassesStatus === "loading" ? (
                              <Col lg={12}><LoadingMessage message="Fetching recent classes..." /></Col>
                            ) : recentClasses.length > 0 ? (
                              recentClasses.map((item) => (
                                <Col lg={4} md={6} sm={12} className="mb-3" key={item._id}>
                                  <div className="recently-active-card h-100 shadow-sm">
                                    <div className="recently-active-head card-body">
                                      <h6 className="card-title" title={item.name} style={{ overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", maxWidth: "100%", wordBreak: "break-all", color: "rgb(43, 54, 116)", fontWeight: "600", fontSize: "16px", lineHeight: "26px", letterSpacing: "-0.02em" }}>
                                        {item.name}
                                      </h6>
                                    </div>
                                    <div className="year-section">
                                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" height="24" width="24">
                                        <path fill="#2b3674" d="M21.5 16.925v-7.05L11.975 15 1 9 11.975 3 23 9v7.925h-1.5ZM11.975 21l-7.25 -3.975v-5.25l7.25 3.975 7.25 -3.975v5.25L11.975 21Z" />
                                      </svg>
                                      <div className="year-desc"><p>Year {item.year}</p></div>
                                    </div>
                                    <div className="owned-section">
                                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" height="24" width="24">
                                        <path fill="#2b3674" d="M3.5 20c-0.4 0 -0.75 -0.15415 -1.05 -0.4625C2.15 19.22915 2 18.88335 2 18.5V5.5c0 -0.38335 0.15 -0.729165 0.45 -1.0375C2.75 4.154165 3.1 4 3.5 4h7.025l1.5 1.5H20.5c0.38335 0 0.72915 0.15415 1.0375 0.4625 0.30835 0.30835 0.4625 0.65415 0.4625 1.0375v11.5c0 0.38335 -0.15415 0.72915 -0.4625 1.0375 -0.30835 0.30835 -0.65415 0.4625 -1.0375 0.4625H3.5Zm7.475 -3.25h8v-0.475c0 -0.7 -0.35415 -1.27085 -1.0625 -1.7125 -0.70835 -0.44165 -1.6875 -0.6625 -2.9375 -0.6625s-2.22915 0.22085 -2.9375 0.6625c-0.70835 0.44165 -1.0625 1.0125 -1.0625 1.7125v0.475Zm4 -4.35c0.5 0 0.92915 -0.17915 1.2875 -0.5375 0.35835 -0.35835 0.5375 -0.7875 0.5375 -1.2875 0 -0.5 -0.17915 -0.92915 -0.5375 -1.2875 -0.35835 -0.35835 -0.7875 -0.5375 -1.2875 -0.5375 -0.5 0 -0.92915 0.17915 -1.2875 0.5375 -0.35835 0.35835 -0.5375 0.7875 -0.5375 1.2875 0 0.5 0.17915 0.92915 0.5375 1.2875 0.35835 0.35835 0.7875 0.5375 1.2875 0.5375Z" />
                                      </svg>
                                      <div className="year-desc">
                                        <p>
                                          Owned by {item.ownerName || item.schoolId?.schoolName || item.schoolId?.name || "N/A"}
                                        </p>
                                      </div>
                                    </div>
                                    <div className="students-section">
                                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" height="24" width="24">
                                        <path fill="#2b3674" d="M0.94995 20.0001v-2.35c0 -0.58335 0.15 -1.1125 0.45 -1.5875 0.3 -0.475 0.71667 -0.82915 1.25 -1.0625 1.21667 -0.53335 2.3125 -0.91665 3.2875 -1.15 0.975 -0.23335 1.97915 -0.35 3.0125 -0.35 1.03335 0 2.03335 0.11665 3 0.35 0.96665 0.23335 2.05835 0.61665 3.275 1.15 0.53335 0.23335 0.95415 0.5875 1.2625 1.0625 0.30835 0.475 0.4625 1.00415 0.4625 1.5875v2.35h-16Zm17.5 0v-2.35c0 -1.05 -0.26665 -1.9125 -0.8 -2.5875 -0.53335 -0.675 -1.23335 -1.22085 -2.1 -1.6375 1.15 0.13335 2.23335 0.32915 3.25 0.5875 1.01665 0.25835 1.84165 0.55415 2.475 0.8875 0.55 0.31665 0.98335 0.70835 1.3 1.175 0.31665 0.46665 0.475 0.99165 0.475 1.575v2.35h-4.6Zm-9.5 -8.025c-1.1 0 -2 -0.35 -2.7 -1.05 -0.7 -0.7 -1.05 -1.6 -1.05 -2.7s0.35 -2 1.05 -2.7c0.7 -0.7 1.6 -1.05 2.7 -1.05s2 0.35 2.7 1.05c0.7 0.7 1.05 1.6 1.05 2.7s-0.35 2 -1.05 2.7c-0.7 0.7 -1.6 1.05 -2.7 1.05Zm9 -3.75c0 1.1 -0.35 2 -1.05 2.7 -0.7 0.7 -1.6 1.05 -2.7 1.05 -0.18335 0 -0.3875 -0.0125 -0.6125 -0.0375 -0.225 -0.025 -0.42915 -0.07085 -0.6125 -0.1375 0.4 -0.41665 0.70415 -0.92915 0.9125 -1.5375 0.20835 -0.60835 0.3125 -1.2875 0.3125 -2.0375s-0.10415 -1.4125 -0.3125 -1.9875c-0.20835 -0.575 -0.5125 -1.10415 -0.9125 -1.5875 0.18335 -0.05 0.3875 -0.09167 0.6125 -0.125 0.225 -0.033335 0.42915 -0.05 0.6125 -0.05 1.1 0 2 0.35 2.7 1.05 0.7 0.7 1.05 1.6 1.05 2.7Z" />
                                      </svg>
                                      <div className="year-desc"><p>{item.studentId?.length || item.studentsCount || item.studentCount || 0} students</p></div>
                                    </div>
                                    <div className="shared-collections">
                                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" height="24" width="24">
                                        <path fill="#2b3674" d="M4 22.0001v-14.525c0 -0.4125 0.146915 -0.76565 0.44075 -1.0595 0.293665 -0.29365 0.64675 -0.4405 1.05925 -0.4405h9c0.4125 0 0.76565 0.14685 1.0595 0.4405 0.29365 0.29385 0.4405 0.647 0.4405 1.0595v14.525l-6 -2.975 -6 2.975Zm14.5 -3.975v-14.55H7.1v-1.5H18.5c0.4125 0 0.76565 0.14683 1.0595 0.4405 0.29365 0.29383 0.4405 0.647 0.4405 1.0595v14.55h-1.5Z" />
                                      </svg>
                                      <div className="year-desc"><p>{item.collectionId?.length || item.collectionsCount || item.collectionCount || 0} shared collections</p></div>
                                    </div>
                                  </div>
                                </Col>
                              ))
                            ) : (
                              <Col lg={12}><NoDataMessage /></Col>
                            )}
                          </Row>
                        </Col>
                      </Row>
                    </div>
                  </div>
                </div>
              </Col>

              <Col xxl={5} lg={12} xl={5} className="mt-4">
                <div className="shadow-sm d-flex flex-column" style={{ height: "650px", background: "#ffffff66", borderRadius: "20px", border: "1px solid #F4F7FE", position: "relative", padding: "15px 20px" }}>
                  <div className="recently-active-chart d-flex flex-column h-100">
                    <div className="recently-main-sec d-flex flex-wrap justify-content-between align-items-center gap-2 mb-4">
                      <div className="recently-head">
                        <h2 className="f-24 m-0" style={{ color: "#2B3674", fontSize: "22px", fontWeight: "700" }}>Recently Shared Collections</h2>
                        {isDateFilter ? (
                          totalCollectionsCount > 0 && (
                            <div className="total-class-head mt-1">
                              <p className="m-0" style={{ color: "#A3AED0", fontSize: "14px" }}>
                                {totalCollectionsCount} active collections during this period
                              </p>
                            </div>
                          )
                        ) : (
                          totalCollectionsCount > 0 && (
                            <div className="total-class-head mt-1">
                              <p className="m-0" style={{ color: "#A3AED0", fontSize: "14px" }}>
                                {totalCollectionsCount} collections total
                              </p>
                            </div>
                          )
                        )}
                      </div>

                      <div className="dash-drop-ad d-flex align-items-center gap-3">
                        <Dropdown onSelect={setSortCollections}>
                          <Dropdown.Toggle
                            variant="success"
                            id="dropdown-collections-sort"
                            className="d-flex align-items-center gap-2"
                            style={{ background: "#F4F7FE", border: "none", color: "#2B3674", borderRadius: "12px", padding: "8px 16px", fontSize: "14px", fontWeight: "600" }}
                          >
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                              <path d="M3 6h18M6 12h12m-9 6h6" />
                            </svg>
                            {sortCollectionOptions[sortCollections] || "Recently shared"}
                          </Dropdown.Toggle>
                          <Dropdown.Menu style={{ borderRadius: "12px", border: "none", boxShadow: "0 10px 25px rgba(0,0,0,0.1)" }}>
                            <Dropdown.Item eventKey="shareDate">Recently shared</Dropdown.Item>
                            <Dropdown.Item eventKey="updatedAt">Recently updated</Dropdown.Item>
                            <Dropdown.Item eventKey="createdAt">Recently created</Dropdown.Item>
                            <Dropdown.Item eventKey="mostShared">Most shared</Dropdown.Item>
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </div>
                    <div className="recently-card scrollable-card-list flex-grow-1" style={{ overflowY: "auto", overflowX: "hidden", paddingRight: "5px", minHeight: 0 }}>
                      <Row className="mx-0">
                        {isLoading || organisationDashboardRecentCollectionsStatus === "loading" ? (
                          <Col lg={12}><LoadingMessage message="Fetching recent collections..." /></Col>
                        ) : recentCollections.length > 0 ? (
                          recentCollections.map((item) => (
                            <Col lg={6} md={6} sm={12} className="mb-3" key={item._id}>
                              <div className="recently-active-card h-100 shadow-sm">
                                <div className="recently-active-head card-body">
                                  <div className="d-flex align-items-center gap-2">
                                    {item.image && (
                                      <img src={item.image} alt="Dashboard visual" style={{ width: "24px", height: "24px", objectFit: "contain" }} />
                                    )}
                                    <h6 className="card-title m-0 text-truncate" title={item.title || item.name} style={{ color: "rgb(43, 54, 116)", fontWeight: "600", fontSize: "16px", lineHeight: "26px", letterSpacing: "-0.02em" }}>
                                      {item.title || item.name}
                                    </h6>
                                  </div>
                                </div>
                                <div className="owned-section">
                                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" height="24" width="24">
                                    <path fill="#2b3674" d="M3.5 20c-0.4 0 -0.75 -0.15415 -1.05 -0.4625C2.15 19.22915 2 18.88335 2 18.5V5.5c0 -0.38335 0.15 -0.729165 0.45 -1.0375C2.75 4.154165 3.1 4 3.5 4h7.025l1.5 1.5H20.5c0.38335 0 0.72915 0.15415 1.0375 0.4625 0.30835 0.30835 0.4625 0.65415 0.4625 1.0375v11.5c0 0.38335 -0.15415 0.72915 -0.4625 1.0375 -0.30835 0.30835 -0.65415 0.4625 -1.0375 0.4625H3.5Zm7.475 -3.25h8v-0.475c0 -0.7 -0.35415 -1.27085 -1.0625 -1.7125 -0.70835 -0.44165 -1.6875 -0.6625 -2.9375 -0.6625s-2.22915 0.22085 -2.9375 0.6625c-0.70835 0.44165 -1.0625 1.0125 -1.0625 1.7125v0.475Zm4 -4.35c0.5 0 0.92915 -0.17915 1.2875 -0.5375 0.35835 -0.35835 0.5375 -0.7875 0.5375 -1.2875 0 -0.5 -0.17915 -0.92915 -0.5375 -1.2875 -0.35835 -0.35835 -0.7875 -0.5375 -1.2875 -0.5375 -0.5 0 -0.92915 0.17915 -1.2875 0.5375 -0.35835 0.35835 -0.5375 0.7875 -0.5375 1.2875 0 0.5 0.17915 0.92915 0.5375 1.2875 0.35835 0.35835 0.7875 0.5375 1.2875 0.5375Z" />
                                  </svg>
                                  <div className="year-desc">
                                    <p>
                                      Owned by {item.schoolId?.schoolName || item.ownedBy || item.ownerName || item.createdBy || "N/A"}
                                    </p>
                                  </div>
                                </div>
                                <div className="videos-section">
                                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" height="24" width="24">
                                    <path fill="#2b3674" d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z" />
                                  </svg>
                                  <div className="year-desc"><p>{item.video?.length || item.videosCount || item.videoCount || 0} videos</p></div>
                                </div>
                                <div className="shared-with-staff">
                                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" height="24" width="24">
                                    <path fill="#2b3674" d="M4 22.0001v-14.525c0 -0.4125 0.146915 -0.76565 0.44075 -1.0595 0.293665 -0.29365 0.64675 -0.4405 1.05925 -0.4405h9c0.4125 0 0.76565 0.14685 1.0595 0.4405 0.29365 0.29385 0.4405 0.647 0.4405 1.0595v14.525l-6 -2.975 -6 2.975Zm14.5 -3.975v-14.55H7.1v-1.5H18.5c0.4125 0 0.76565 0.14683 1.0595 0.4405 0.29365 0.29383 0.4405 0.647 0.4405 1.0595v14.55h-1.5Z" />
                                  </svg>
                                  <div className="year-desc"><p>Shared with {item.sharedWithTeachersOrAdminsCount || item.sharesCount || item.shareCount || 0} staff members</p></div>
                                </div>
                              </div>
                            </Col>
                          ))
                        ) : (
                          <Col lg={12}><NoDataMessage /></Col>
                        )}
                      </Row>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>

            <Row className="mb-4 align-items-stretch">
              <Col xxl={5} lg={5} className="mt-2">
                <div className="shadow-sm d-flex flex-column h-100 w-100" style={{ background: "#ffffff66", borderRadius: "20px", border: "1px solid #F4F7FE", padding: "15px 20px" }}>
                  <div className="results-sec d-flex flex-column h-100 w-100">
                    <div className="recently-active-chart d-flex flex-column h-100 w-100">
                      <div className="d-flex justify-content-between align-items-center mb-4 text-start w-100">
                        <div className="d-flex align-items-center gap-3 justify-content-start flex-grow-1 w-100">
                          <h2 className="f-24 m-0 text-start" style={{ color: "#2B3674", fontSize: "24px" }}>Recently Active Staff</h2>
                          <div className="d-flex align-items-center gap-2" style={{ color: "#2B3674", opacity: 0.8 }}>
                            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                              <path d="M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z" />
                            </svg>
                            <span style={{ fontSize: "14px", fontWeight: "600" }}>{recentStaff.length} staff total</span>
                            <div className="d-flex align-items-center gap-1 ms-2">
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke={sortOrder === "asc" ? "#D5008D" : "#2B3674"}
                                strokeWidth="3"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                style={{ cursor: "pointer" }}
                                onClick={() => setSortOrder("asc")}
                              >
                                <path d="M12 19V5M5 12l7-7 7 7" />
                              </svg>
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke={sortOrder === "desc" ? "#D5008D" : "#2B3674"}
                                strokeWidth="3"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                style={{ cursor: "pointer" }}
                                onClick={() => setSortOrder("desc")}
                              >
                                <path d="M12 5v14M5 12l7 7 7-7" />
                              </svg>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="Review-history mt-4 scrollable-card-list flex-grow-1 w-100" style={{ overflowY: "auto", overflowX: "hidden", paddingRight: "5px", minHeight: 0 }}>
                        {isLoading || organisationDashboardRecentActiveStaffStatus === "loading" ? (
                          <LoadingMessage message="Fetching active staff..." />
                        ) : recentStaff.length > 0 ? (
                          <Row className="mx-0 w-100">
                            {recentStaff.map((item, index) => (
                              <Col lg={6} md={12} className="mb-3" key={`${item._id}-${index}`}>
                                <div
                                  className="staff-card shadow-sm p-2 d-flex align-items-center gap-3 w-100 text-start"
                                  style={{
                                    cursor: "pointer",
                                    background: "#FFFFFF",
                                    borderRadius: "20px",
                                    border: "1px solid rgba(244, 247, 254, 1)",
                                    transition: "all 0.3s ease"
                                  }}
                                  onClick={() => navigate(`/organisations/staff-detail/${item._id}/${item.accountType}`)}
                                >
                                  <div className="avatar-wrapper" style={{ flexShrink: 0 }}>
                                    {item.image ? (
                                      <img
                                        src={item.image}
                                        alt="Dashboard visual"
                                        style={{ width: "50px", height: "50px", borderRadius: "15px", objectFit: "cover" }}
                                      />
                                    ) : (
                                      <div style={{
                                        width: "50px",
                                        height: "50px",
                                        background: "rgba(43, 54, 116, 0.05)",
                                        borderRadius: "15px",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        color: "#2B3674",
                                        fontWeight: "700",
                                        fontSize: "16px"
                                      }}>
                                        {(item.firstName?.charAt(0) || "")}{(item.surName?.charAt(0) || item.lastName?.charAt(0) || "")}
                                      </div>
                                    )}
                                  </div>
                                  <div className="staff-info overflow-hidden flex-grow-1 text-start">
                                    <h6 className="m-0 text-truncate" style={{ fontSize: "16px", color: "#2B3674", fontWeight: "700" }}>
                                      {item.firstName} {item.surName || item.lastName}
                                    </h6>
                                    {(item.school?.schoolName || item.schoolName) && (
                                      <p className="m-0 text-truncate" style={{ color: "#A3AED0", fontSize: "13px", fontWeight: "500" }} title={(item.school?.schoolName || item.schoolName).trim()}>
                                        {(item.school?.schoolName || item.schoolName).trim()}
                                      </p>
                                    )}
                                    <p className="m-0 text-truncate" style={{ color: "#A3AED0", fontSize: "13px", fontWeight: "500" }}>
                                      {formatLastActive(item.lastLoggedIn)}
                                    </p>
                                  </div>
                                </div>
                              </Col>
                            ))}
                          </Row>
                        ) : (
                          <NoDataMessage />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </Col>

              <Col xxl={7} lg={7} className="mt-2">
                <div className="shadow-sm d-flex flex-column" style={{ background: "#ffffff66", borderRadius: "20px", border: "1px solid #F4F7FE", padding: "15px 20px" }}>
                  <h2 className="f-24 m-0 mb-4" style={{ color: "#2B3674", fontSize: "24px" }}>Most Shared Videos</h2>
                  <div className="Review-history mt-3 flex-grow-1 d-flex flex-column">
                    {isLoading || organisationDashboardStaffSharedVideosStatus === "loading" ? (
                      <LoadingMessage message="Fetching most shared videos..." />
                    ) : organisationDashboardStaffSharedVideosStatus === "failed" ? (
                      <div className="text-center p-4">
                        <p className="data-not-found-cmn">Unable to load videos. Please try again later.</p>
                      </div>
                    ) : organisationDashboardStaffSharedVideos.length > 0 ? (
                      <div
                        className="w-100"
                        style={{
                          overflow: "auto",
                        }}
                      >
                        <table className="table table-borderless" style={{ background: "transparent", backgroundColor: "transparent" }}>
                          <thead>
                            <tr style={{ borderBottom: "1px solid #F4F7FE", background: "transparent", backgroundColor: "transparent" }}>
                              <th
                                style={{
                                  color: "#2B3674",
                                  fontSize: "14px",
                                  fontWeight: "700",
                                  paddingBottom: "15px",
                                  width: "30%",
                                  maxWidth: "150px",
                                  background: "transparent",
                                  backgroundColor: "transparent",
                                }}
                              >
                                Member Organisation
                              </th>
                              <th
                                style={{
                                  color: "#2B3674",
                                  fontSize: "14px",
                                  fontWeight: "700",
                                  paddingBottom: "15px",
                                  background: "transparent",
                                  backgroundColor: "transparent",
                                }}
                              >
                                Top Shared Videos
                              </th>
                            </tr>
                          </thead>
                          <tbody style={{ background: "transparent", backgroundColor: "transparent" }}>
                            {(() => {
                              const map = {};
                              (organisationDashboardStaffSharedVideos || []).forEach(video => {
                                if (video.group && Array.isArray(video.group) && video.group.length > 0) {
                                  video.group.forEach(groupId => {
                                    const groupObj = groupData.find(g => g.id === groupId);
                                    const name = groupObj ? groupObj.name : "Other";
                                    if (!map[name]) map[name] = [];
                                    if (!map[name].find(v => v._id === video._id)) {
                                      map[name].push(video);
                                    }
                                  });
                                } else {
                                  if (!map["Other"]) map["Other"] = [];
                                  if (!map["Other"].find(v => v._id === video._id)) {
                                    map["Other"].push(video);
                                  }
                                }
                              });
                              
                              const groupedArray = Object.keys(map).map(key => ({
                                schoolName: key,
                                topSharedVideos: map[key]
                              }));

                              return groupedArray.map((staff, idx) => (
                                <tr
                                  key={idx}
                                  style={{
                                    borderBottom:
                                      idx !== groupedArray.length - 1
                                        ? "1px solid #F4F7FE"
                                        : "none",
                                    background: "transparent",
                                    backgroundColor: "transparent",
                                  }}
                                >
                                  <td
                                    className="py-3"
                                    style={{
                                      color: "#2B3674",
                                      fontWeight: "500",
                                      fontSize: "15px",
                                      width: "30%",
                                      maxWidth: "150px",
                                      whiteSpace: "normal",
                                      wordBreak: "break-word",
                                      background: "transparent",
                                      backgroundColor: "transparent",
                                    }}
                                    title={staff.schoolName}
                                  >
                                    {staff.schoolName}
                                  </td>
                                  <td className="py-3" style={{ background: "transparent", backgroundColor: "transparent" }}>
                                    <div className="d-flex align-items-center gap-3">
                                      {staff.topSharedVideos?.map((video, vIdx) => (
                                        <OverlayTrigger
                                          key={vIdx}
                                          placement="top"
                                          overlay={
                                            <Tooltip>
                                              {video.title}: {video.shared || video.shares || video.sharesCount || video.shareCount || video.views || 0} shares
                                            </Tooltip>
                                          }
                                        >
                                          <div
                                            className="d-flex flex-column align-items-center"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => {
                                              const catId = video.category?._id || video.categoryId?._id || video.category || video.categoryId || "";
                                              navigate(`/video-shorts/${Encryptedid(catId)}/${video._id}`, {
                                                state: { page: "dashboard", videoObj: video },
                                              });
                                            }}
                                          >
                                            <img
                                              src={video.cover_url || video.thumbnail || video.image || fallbackThumb}
                                              alt={video.title}
                                              style={{
                                                width: "45px",
                                                height: "65px",
                                                borderRadius: "8px",
                                                objectFit: "cover",
                                                marginBottom: "2px",
                                              }}
                                            />
                                            <span
                                              style={{
                                                fontSize: "11px",
                                                color: "#707EAE",
                                                fontWeight: "600",
                                              }}
                                            >
                                              {video.shared || video.shares || video.sharesCount || video.shareCount || video.views || 0}
                                            </span>
                                          </div>
                                        </OverlayTrigger>
                                      ))}
                                    </div>
                                  </td>
                                </tr>
                              ));
                            })()}
                          </tbody>
                        </table>
                      </div>
                    ) : (
                      <NoDataMessage />
                    )}
                  </div>
                </div>
              </Col>
            </Row>
          </>

  );
};
